"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { Tooltip, TooltipTrigger } from "@/components/rac/tooltip";
import { MapItemSUP } from "@/types/search";
import { trackEvent } from "@/utils/analytics/track-event";
import { GitCompare, Loader2 } from "lucide-react";
import { ButtonProps } from "react-aria-components";
export interface CompareButtonProps extends Omit<ButtonProps, "onPress"> {
  property: MapItemSUP;
  isInComparison?: boolean;
  onToggleComparison?: (property: MapItemSUP) => void;
  isLoading?: boolean;
  variant?: "icon" | "full";
}
export function CompareButton(t0) {
  const $ = _c(38);
  let className;
  let onToggleComparison;
  let property;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      property,
      isInComparison: t1,
      onToggleComparison,
      isLoading: t2,
      variant: t3,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onToggleComparison;
    $[3] = property;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    className = $[1];
    onToggleComparison = $[2];
    property = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  const isInComparison = t1 === undefined ? false : t1;
  const isLoading = t2 === undefined ? false : t2;
  const variant = t3 === undefined ? "icon" : t3;
  let t4;
  if ($[8] !== isInComparison || $[9] !== onToggleComparison || $[10] !== property) {
    t4 = () => {
      if (onToggleComparison) {
        onToggleComparison(property);
        trackEvent({
          google: {
            event: isInComparison ? "remove_from_comparison" : "add_to_comparison",
            options: {
              property_id: property._id,
              property_type: property.type,
              source: "compare_button"
            }
          }
        });
      }
    };
    $[8] = isInComparison;
    $[9] = onToggleComparison;
    $[10] = property;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleClick = t4;
  const handleNativeClick = _temp;
  const ariaLabel = isInComparison ? "Remove from comparison" : "Add to comparison";
  if (variant === "icon") {
    const t5 = isInComparison ? "bareshell" : "outline";
    const t6 = `w-10 h-10 rounded-xl border-gray-300 hover:bg-gray-50 transition-colors data-[hovered]:translate-y-0 ${className || ""}`;
    let t7;
    if ($[12] !== isInComparison || $[13] !== isLoading) {
      t7 = isLoading ? <Loader2 className="w-5 h-5 animate-spin" aria-hidden="true" /> : <GitCompare className={`w-5 h-5 ${isInComparison ? "fill-primary text-primary-700" : ""}`} aria-hidden="true" />;
      $[12] = isInComparison;
      $[13] = isLoading;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== ariaLabel || $[16] !== handleClick || $[17] !== isLoading || $[18] !== props || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
      t8 = <Button variant={t5} size="icon" className={t6} isPending={isLoading} isDisabled={isLoading} onPress={handleClick} onClick={handleNativeClick} aria-label={ariaLabel} {...props}>{t7}</Button>;
      $[15] = ariaLabel;
      $[16] = handleClick;
      $[17] = isLoading;
      $[18] = props;
      $[19] = t5;
      $[20] = t6;
      $[21] = t7;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    let t9;
    if ($[23] !== ariaLabel) {
      t9 = <Tooltip placement="left">{ariaLabel}</Tooltip>;
      $[23] = ariaLabel;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    let t10;
    if ($[25] !== t8 || $[26] !== t9) {
      t10 = <TooltipTrigger>{t8}{t9}</TooltipTrigger>;
      $[25] = t8;
      $[26] = t9;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    return t10;
  }
  const t5 = isInComparison ? "accent" : "outline";
  const t6 = `flex items-center gap-2 ${className || ""}`;
  let t7;
  if ($[28] !== isInComparison || $[29] !== isLoading) {
    t7 = isLoading ? <><Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /><span>Processing...</span></> : <><GitCompare className="w-4 h-4" aria-hidden="true" /><span>{isInComparison ? "In Comparison" : "Compare"}</span></>;
    $[28] = isInComparison;
    $[29] = isLoading;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== handleClick || $[32] !== isLoading || $[33] !== props || $[34] !== t5 || $[35] !== t6 || $[36] !== t7) {
    t8 = <Button variant={t5} size="sm" className={t6} isPending={isLoading} isDisabled={isLoading} onPress={handleClick} onClick={handleNativeClick} {...props}>{t7}</Button>;
    $[31] = handleClick;
    $[32] = isLoading;
    $[33] = props;
    $[34] = t5;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  return t8;
}
function _temp(e) {
  e.preventDefault();
  e.stopPropagation();
}